import { FaSearch, FaHotel, FaFire, FaBus } from 'react-icons/fa';
import { MdDiscount } from 'react-icons/md';
import { RiShip2Fill } from 'react-icons/ri';
import { Link } from 'react-router-dom';

const LinksBar = () => {
  const isIndexPage = window.location.pathname === '/';

  return (
    <div className={`links-bar`}>
      <Link to="" className="active" aria-label="Поиск туров" target="_blank">
        <FaSearch />
        <span>поиск {isIndexPage ? 'туров' : ''}</span>
      </Link>
      <Link
        className={`link-hotel`}
        to="/tourist/poisk-otelya/"
        target="_blank"
        aria-label="Отели без перелета"
      >
        <FaHotel />
        <span>отели</span>
      </Link>
      <Link
        className={`link-hot`}
        to="/tourist/goryashie-tury/"
        target="_blank"
        aria-label="Горящие туры"
      >
        <FaFire />
        <span>горящие{isIndexPage ? ' туры' : ''}</span>
      </Link>
      <Link
        className={`link-bus`}
        to="/excursions/russia/"
        target="_blank"
        aria-label="Экскурсионные туры"
      >
        <FaBus />
        <span>{isIndexPage ? 'экскурсионные туры' : 'экскурсии'}</span>
      </Link>
      <Link
        className={`link-cruise`}
        to="/tourist/kruizy/"
        aria-label="Круизы"
        target="_blank"
      >
        <RiShip2Fill />
        <span>круизы</span>
      </Link>
      <Link
        className={`link-discount`}
        to="/tourist/akcii-i-skidki/"
        aria-label="Распродажа"
        target="_blank"
      >
        <MdDiscount />
        <span>Распродажа{isIndexPage ? ' туров' : ''}</span>
      </Link>
    </div>
  );
};
export default LinksBar;
